export const hostPaths = {
  home: '/host',
  mabar: {
    list: '/host/mabar',
    create: '/host/mabar/create',
    edit: (slug: string) => `/host/mabar/${slug}/edit`,
    details: (slug: string) => `/host/mabar/${slug}/details`,
    dashboard: (slug: string) => `/host/mabar/${slug}/dashboard`,
    analitik: (slug: string) => `/host/mabar/${slug}/statistic`,
    badminton: (slug: string) => `/host/mabar/${slug}/badminton`,
    badmintonTambahGame: (slug: string) => `/host/mabar/${slug}/badminton/tambah-game`,
    badmintonEditSkor: (slug: string, gameSlug: string) =>
      `/host/mabar/${slug}/badminton/game/${gameSlug}/skor`,
    padel: (slug: string) => `/host/mabar/${slug}/padel`,
    padelTambahGame: (slug: string) => `/host/mabar/${slug}/padel/tambah-game`,
    padelEditSkor: (slug: string, gameSlug: string) =>
      `/host/mabar/${slug}/padel/game/${gameSlug}/skor`,
    pickleball: (slug: string) => `/host/mabar/${slug}/pickleball`,
    gameHasil: (gameSlug: string) => `/host/mabar/game/${gameSlug}/hasil`,
    gameRekap: (gameSlug: string) => `/host/mabar/game/${gameSlug}/rekap`,
    gameCreate: (slug: string) => `/host/mabar/${slug}/game/create`,
    gameEdit: (slug: string, gameSlug: string) => `/host/mabar/${slug}/game/${gameSlug}/edit`,
  },
  members: '/host/members',
  hosts: '/host/hosts',
  wallet: '/host/wallet',
  menu: '/host/menu',
  transactions: '/host/transactions',
  whatsapp: '/host/whatsapp',
  profile: {
    settings: '/host/profile-settings',
    editInfo: '/host/profile-settings/edit-info',
    delete: '/host/profile-settings/delete',
  },
} as const;

export const HOST_PATH_PREFIX = '/host';

export function hostMabarStatistikPath(eventSlug: string, sportCategory?: string | null): string {
  const sport = (sportCategory || '').toLowerCase();
  if (sport.includes('badminton')) return hostPaths.mabar.badminton(eventSlug);
  if (sport.includes('padel')) return hostPaths.mabar.padel(eventSlug);
  if (sport.includes('pickleball')) return hostPaths.mabar.pickleball(eventSlug);
  return hostPaths.mabar.analitik(eventSlug);
}
